/**
 * Operator labels — document correction ops review decision V0.
 */

export const DOCUMENT_CORRECTION_OPS_REVIEW_DECISION_OPERATOR_LABELS = {
  reviewSectionTitle: 'Review decision',
  reviewBoundaryCopy:
    'Approve or reject this under_review correction request. Does not mutate parent document truth or durable Approval.',
  approve: 'Approve',
  reject: 'Reject',
  reasonCodeLabel: 'Reason code',
  safeExplanationLabel: 'Customer-safe explanation',
  safeExplanationPlaceholder: 'Explanation visible to the customer.',
  confirmApprove: 'Confirm approve',
  confirmReject: 'Confirm reject',
  cancel: 'Cancel',
  reviewUnavailable: 'You do not have permission to approve or reject.',
  loadContextFailed: 'Failed to load review context.',
  mutationFailed: 'Failed to record review decision.',
  staleSource: 'Review source is stale. Refresh and try again.',
  successApprove: 'Request approved for internal handling.',
  successReject: 'Request not approved.',
  terminalApproved: 'Already approved.',
  terminalRejected: 'Already rejected.',
  notReviewable: 'Not reviewable (open info request or wrong state).',
} as const;
